var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-medium bg-white flex-1 flex flex-col justify-between h-full w-full max-h-full overflow-hidden pb-4"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }